goog.provide('el8.ext.onboarding.signupData');

goog.require('el8.model.base');

el8.ext.onboarding.signupData = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('password');
    _class.addStringProperty('fullName');

    _class.addProperty('selectedLabs');
    _class.addStringProperty('addlLabs');

    _class.addBoolean('authorized');
    _class.addStringProperty('signature');

    _class.addIntProperty('profileId');
    _class.addStringProperty('confirmCredential', true);

    _class.addStringProperty('firstName', true);
    _class.addStringProperty('middleName', true);
    _class.addStringProperty('lastName', true);

    _class.addStringProperty('suffix', true);
    _class.addStringProperty('credential', true);

    _class.addStringProperty('address', true);
    _class.addStringProperty('suite', true);
    _class.addStringProperty('city', true);
    _class.addStringProperty('state', true);
    _class.addStringProperty('zip', true);
    _class.addStringProperty('phone', true);
    _class.addStringProperty('fax', true);

    _class.addStringProperty('npi', true);
    _class.addStringProperty('licenseNumber', true);
    _class.addStringProperty('licenseState', true);

    _class.prototype.getFormalName = function() {
        return (this.getFullName() ? this.getFullName() :
            (this.getFirstName() + (this.getMiddleName() ? ' '+this.getMiddleName() : '')
             + ' '+this.getLastName() + (this.getSuffix() ? ' '+this.getSuffix() : '')))
            + ', ' + (this.getConfirmCredential() || this.getCredential());
    };

    return new _class({});

})();


